import { Button, Tooltip } from "@fluentui/react-components";
import { TableCursorRegular } from "@fluentui/react-icons";
import * as React from "react";

export type validationStateType = "none" | "success" | "error" | "warning";

interface TargetValueInputProps {
  toolTipStr: string
  buttonClassName: string
  handleClick: React.MouseEventHandler;
}

const GetFromXlWsButton: React.FC<TargetValueInputProps> = (
  props: TargetValueInputProps
) => {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "8px"}}>
            <Tooltip
              content={props.toolTipStr}
              relationship="description"
            >
              <Button
                className={props.buttonClassName}
                icon={<TableCursorRegular />}
                onClick={props.handleClick}
              />
            </Tooltip>
      </div>
    </>
  );
};

export default GetFromXlWsButton;
